import React from 'react';

export const wheelColumnWebStyle: React.CSSProperties = {
  touchAction: 'none',
  overscrollBehavior: 'contain',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  WebkitTouchCallout: 'none',
};

export const wheelItemWebStyle: React.CSSProperties = {
  userSelect: 'none',
  WebkitUserSelect: 'none',
};

export const wheelTrackWebStyle: React.CSSProperties = {
  willChange: 'transform',
};